import { PartnerNotesData } from 'store/partnerNotes';
import { MobileNavItem } from '../MobileNav';
import { TrackEvent } from 'contexts/analytics/types';

type Props = {
  partnerNote: PartnerNotesData[string];
  isPartnerRecommendationNoteEnabled: boolean;
  trackEvent: TrackEvent;
};

export default function getNavItemParameters({
  partnerNote,
  isPartnerRecommendationNoteEnabled,
  trackEvent,
}: Props): Parameters<typeof MobileNavItem>[0] {
  if (partnerNote && isPartnerRecommendationNoteEnabled)
    return {
      pathname: `partner-recs/${partnerNote.partner.id}`,
      iconName: 'thumbStar',
      activeIconName: 'thumbStarFilled',
      label: `${partnerNote.partner.name} Recs`,
      iconClassName: 'partnerRecsIcon',
      onClick: () => trackEvent('Partner Recs Nav Clicked'),
    };

  return {
    pathname: 'bookmarks',
    iconName: 'bookmark',
    activeIconName: 'bookmarkFilled',
    label: 'Bookmarks',
  };
}
